import post from './post';

export default { post };
